import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";

export default function TermsOfService() {
  const { theme } = useTheme();
  const logoSrc = theme === "light" ? "/logo-light.png" : "/logo.png";

  return (
    <div style={{
      minHeight: "100vh",
      background: "var(--bg-base)",
      padding: "48px 24px",
      color: "var(--text-primary)",
    }}>
      <div style={{ maxWidth: 720, margin: "0 auto" }}>

        {/* Header */}
        <div style={{ marginBottom: 40 }}>
          <Link to="/login" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, color: "var(--text-muted)", textDecoration: "none", marginBottom: 28 }}>
            ← Volver al inicio
          </Link>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
            <img src={logoSrc} alt="Creativedog" style={{ height: 28 }} />
          </div>
          <h1 style={{ fontSize: 28, fontWeight: 700, color: "var(--text-primary)", marginBottom: 8 }}>
            Condiciones del Servicio
          </h1>
          <p style={{ fontSize: 14, color: "var(--text-muted)" }}>
            Última actualización: abril de 2026
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>

          <Section title="1. Descripción del servicio">
            <p>
              Smith es una plataforma interna de inteligencia artificial desarrollada y operada por <strong>Creativedog Agency</strong>. Proporciona acceso a agentes de IA especializados en marketing digital (estrategia, contenido, SEO, ads, reportes, entre otros) para apoyar la gestión de los clientes de la agencia.
            </p>
            <p>
              El uso de Smith está reservado exclusivamente para miembros del equipo de Creativedog Agency y colaboradores externos habilitados de forma expresa por un administrador.
            </p>
          </Section>

          <Section title="2. Acceso y condiciones de uso">
            <p>
              Al acceder a Smith, el usuario declara que:
            </p>
            <ul>
              <li>Es miembro del equipo de Creativedog Agency o un colaborador expresamente autorizado.</li>
              <li>Utilizará la plataforma exclusivamente para fines laborales y relacionados con la actividad de la agencia.</li>
              <li>No compartirá sus credenciales de acceso con terceros.</li>
              <li>No intentará acceder a clientes, conversaciones o datos que no le correspondan según los permisos asignados.</li>
            </ul>
          </Section>

          <Section title="3. Uso de inteligencia artificial">
            <p>
              Smith utiliza la API de Claude (Anthropic) para procesar las conversaciones con los agentes. Al enviar mensajes a través de la plataforma, el contenido es procesado por los servidores de Anthropic según sus propias políticas de uso. Creativedog Agency no garantiza la precisión, completitud o idoneidad de las respuestas generadas por los agentes de IA.
            </p>
            <p>
              Las respuestas de los agentes son de carácter orientativo y deben ser revisadas por el usuario antes de ser utilizadas en comunicaciones con clientes o en decisiones de negocio.
            </p>
          </Section>

          <Section title="4. Confidencialidad">
            <p>
              La información de clientes, conversaciones e información estratégica disponible en Smith es estrictamente confidencial. El usuario se compromete a:
            </p>
            <ul>
              <li>No divulgar información de clientes fuera del ámbito laboral de Creativedog Agency.</li>
              <li>No exportar, copiar ni compartir contenido de la plataforma con terceros no autorizados.</li>
              <li>Notificar de inmediato a un administrador ante cualquier acceso no autorizado o uso indebido de la plataforma.</li>
            </ul>
          </Section>

          <Section title="5. Propiedad intelectual">
            <p>
              Todo el contenido, interfaces, código y funcionalidades de Smith son propiedad de Creativedog Agency. Los contenidos generados por los agentes de IA en el contexto del trabajo con clientes se consideran activos de trabajo de la agencia.
            </p>
          </Section>

          <Section title="6. Limitación de responsabilidad">
            <p>
              Creativedog Agency no se responsabiliza por:
            </p>
            <ul>
              <li>Errores, inexactitudes o sesgos en las respuestas generadas por los agentes de IA.</li>
              <li>Pérdidas de datos derivadas de interrupciones del servicio o fallas técnicas.</li>
              <li>Decisiones tomadas en base a la información proporcionada por los agentes sin revisión humana.</li>
            </ul>
            <p>
              La plataforma se ofrece "tal como está" para uso interno. No constituye un servicio comercial externo.
            </p>
          </Section>

          <Section title="7. Suspensión del acceso">
            <p>
              Creativedog Agency se reserva el derecho de suspender o revocar el acceso de cualquier usuario en cualquier momento, sin previo aviso, en caso de:
            </p>
            <ul>
              <li>Uso indebido o contrario a estas condiciones.</li>
              <li>Fin de la relación laboral o de colaboración con la agencia.</li>
              <li>Necesidades operativas o de seguridad de la plataforma.</li>
            </ul>
          </Section>

          <Section title="8. Modificaciones">
            <p>
              Creativedog Agency puede modificar estas condiciones en cualquier momento. Las modificaciones entrarán en vigor de forma inmediata. El uso continuado de la plataforma implica la aceptación de las condiciones vigentes.
            </p>
          </Section>

          <Section title="9. Contacto">
            <p>
              Para consultas sobre estas condiciones, escribinos a{" "}
              <a href="mailto:hello@creativedog.agency" style={{ color: "var(--accent)" }}>hello@creativedog.agency</a>.
            </p>
          </Section>

        </div>

        <div style={{ marginTop: 48, paddingTop: 24, borderTop: "1px solid var(--border)", display: "flex", gap: 20, fontSize: 13, color: "var(--text-muted)" }}>
          <Link to="/login" style={{ color: "var(--accent)", textDecoration: "none" }}>← Volver al inicio</Link>
          <Link to="/politicas-de-privacidad" style={{ color: "var(--text-muted)", textDecoration: "none" }}>Políticas de Privacidad →</Link>
        </div>

      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 style={{
        fontSize: 16, fontWeight: 600, color: "var(--text-primary)",
        marginBottom: 12, paddingBottom: 8, borderBottom: "1px solid var(--border)",
      }}>
        {title}
      </h2>
      <div style={{ fontSize: 14, color: "var(--text-secondary)", lineHeight: 1.8, display: "flex", flexDirection: "column", gap: 10 }}>
        {children}
      </div>
    </div>
  );
}
